import { usePublicSettings } from './usePublicSettings';

export function useFIPSMode() {
  const { isLoading, data } = usePublicSettings();

  return !isLoading && !!data && !!data.FIPSMode;
}
